import { createSelector } from 'reselect';

import { RootState } from '@/app/store';

const selectLeaderboardState = (state: RootState) => state.leaderboard;

export const selectLeaderboardEntries = createSelector(
  selectLeaderboardState,
  (s) => s.entries,
);

export const selectLeaderboardOffset = createSelector(
  selectLeaderboardState,
  (s) => s.offset,
);

export const selectLeaderboardHasMore = createSelector(
  selectLeaderboardState,
  (s) => s.hasMore,
);

export const selectLeaderboardLoading = createSelector(
  selectLeaderboardState,
  (s) => s.loading,
);

export const selectLeaderboardInitialLoading = createSelector(
  selectLeaderboardState,
  (s) => s.initialLoading,
);

export const selectLeaderboardPeriod = createSelector(
  selectLeaderboardState,
  (s) => s.period,
);

export const selectLeaderboardSortBy = createSelector(
  selectLeaderboardState,
  (s) => s.sortBy,
);

export const selectLeaderboardMyRank = createSelector(
  selectLeaderboardState,
  (s) => s.myRank,
);

export const selectLeaderboardGameType = createSelector(
  selectLeaderboardState,
  (s) => s.gameType,
);
